import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { Tenant, TenantArrayConverter } from "./tenants";

@JsonConverter
export class MeConverter implements JsonCustomConvert<Me>{
	serialize() { }
	deserialize(data: any): Me {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Me);
	}
}

@JsonObject("Me")
export class Me{
    @JsonProperty("uuid", String, true)
	uuid: string = "";
    @JsonProperty("first_name", String, true)
	first_name: string = "";
    @JsonProperty("last_name", String, true)
	last_name: string = "";
    @JsonProperty("role", String, true)
	role: string = "";
    @JsonProperty("tenants", TenantArrayConverter, true)
    tenants:Array<Tenant> = [];
}

@JsonObject("MeTable")
export class MeTable extends BaseResponse {
    @JsonProperty("data", MeConverter, true)
    data: Me = new Me();
}